import React from "react";
import {
  ControlLabel,
  FormControl, FormGroup, HelpBlock
} from "react-bootstrap";
import "./style.scss";
import { Images } from "../../assets";

const InputField = ({
  field: { name, value, onChange, disabled },
  form: { errors, touched },
  label = "",
  labelStyles = { color: "inherit" },
  valueStyles = {},
  type = "text",
  applyDefaultLabelClass = true,
  min,
  placeholder = "",
  handleBlur,
  showError = true,
  customError = "",
  className = "input-container form-group",
  showPassword,
  ...props
}) => {

  return (
    <FormGroup
      controlId={name}
      validationState={touched[name] && errors[name] ? "error" : null}
      bsClass={className}
    >
      {label && (
        <div className={ applyDefaultLabelClass ? "text-area-tooltip": ""}>
          <ControlLabel style={labelStyles}>{label}</ControlLabel>
        </div>
      )}

      <FormControl
        disabled={disabled}
        name={name}
        type={type}
        min={min}
        value={disabled ? "" : value ?? ""}
        onChange={onChange}
        className = {`${(showError && customError )&& 'no-border add-error-border'} input-component`}
        onBlur={() => {
          if (typeof handleBlur === "function") {
            handleBlur(value);
          }
        }}
        style={valueStyles}
        placeholder={placeholder}
        autoComplete="off"
        {...props}
      />

      {showPassword && (
        <div className="input-field-icon" onClick={showPassword}>
          <img
            src={type === "password" ? Images.showPasswordSvg: Images.hidePasswordSvg}
            alt="show-password"
            className = "input-field-icon"
          />
        </div>
      )}

      {showError && <HelpBlock>{touched[name] && (customError || errors[name])}</HelpBlock>}
    </FormGroup>
  );
};

export { InputField };
